//@flow

import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Select } from 'common/components/core/select';
import ReadOnlyField from 'common/entity/generic/ReadOnlyField';
import { getLanguageFilterOptions } from 'common/constants/languageCodes';
import personnelMasterIds from 'common/tests/masterManagement/personnelMaster.json';

type Props = {
    value: string,
    onChange: (value: ?string) => void,
    placeholder: string
};

const PersonnelLanguageInput = (props: Props): React.Node => {
    const { value, placeholder, onChange } = props;
    const { t } = useTranslation('entityManagement');
    const handleChange = updatedOption => {
        onChange(updatedOption?.value || null);
    };
    const filterOptions = getLanguageFilterOptions(t);
    return (
        <>
            <Select
                maxMenuHeight={190}
                noMarginBottom
                options={filterOptions}
                openMenuOnFocus
                blurInputOnSelect={false}
                isSearchable={false}
                placeholder={t(placeholder)}
                value={value}
                /* eslint-disable react/jsx-no-bind */
                onChange={handleChange}
                testId={personnelMasterIds.addNewPersonnel.inputLanguage}
            />
            <ReadOnlyField
                label={t('masterPersonnelForm.language')}
                value={value}
            />
        </>
    );
};

export default PersonnelLanguageInput;
